import { Component, Host, h, Prop, State } from '@stencil/core';

@Component({
    tag: 'profile-card',
    styleUrl: 'profile-card.scss',
    shadow: false,
    scoped: false

})


export class ProfileCard {
  @Prop() buttonText: string;
  @Prop() href: string;
  @Prop() target: string = ""
  render() {
    return (
      <div class="profile-card">
        <div class="profile-card-header">
          <div class="profile-card-icon">
            <slot name="image" />
          </div>
        </div>
        <div class="profile-card-body">
          <slot />
          <a class="btn btn-outline-primary" href={this.href} target={this.target}>
            {this.buttonText}
            <i class="bi bi-arrow-right ml-1"></i>
          </a>
        </div>
      </div>
    )
  }
}

